import { FileExclamationOutlined } from "@ant-design/icons";
import { cn } from "../../lib/utils";
import { Link } from "react-router-dom";

export default function AlertTile({ entityName, kind, documentName, id, expireAt }) {
    return (
        <div className="flex h-[76px] items-center space-x-4  w-full px-[16px] py-[24px]">
            <FileExclamationOutlined className={cn("h-[24px] w-[24px] text-[24px]  text-red-500")} />
            <p><Link to={`/${kind}/${id}`} className="text-blue-500 cursor-pointer">{entityName}'s </Link> {documentName} is Expiring on <span className="font-semibold">{expireAt}</span></p>
        </div>
    )
}
